var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('o-form-checkbox',{attrs:{"name":"accept_tos","required":""}},[_vm._v("\n    I accept  \n    "),_c('o-link',{attrs:{"to":{name: 'terms'},"target":"_blank"}},[_vm._v("Terms of use")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }